import React from 'react';
import {
    Modal, Button, Container, Row, Col
} from 'react-bootstrap';

function JournalOrCreatePopup(props) {

    function onCreateNewPet() {
        props.onCreateNewPet(props.selection);
    }

    function onGoToPet() {
        props.onGoToPet(props.selection);
    }

    function getButtons() {
        if (props.allowCreate) {
            if (props.selection?.isPet()) {
                return (
                    <Container>
                        <Row>
                            <Col>
                                <Button variant="success" onClick={onGoToPet}>Gå till journal</Button>
                            </Col>
                            <Col>
                                <Button variant="secondary" onClick={onCreateNewPet}>Nytt djur på kund</Button>
                            </Col>
                        </Row>
                    </Container>
                );
            }
            else {
                return (
                    <Container>
                        <Row>
                            <Col>
                                <Button variant="success" onClick={onCreateNewPet}>Nytt djur på kund</Button>
                            </Col>
                        </Row>
                    </Container>
                );
            }
        }
        else {
            if (props.selection?.isPet()) {
                return (
                    <Container>
                        <Row>
                            <Col>
                                <Button variant="success" onClick={onGoToPet}>Välj djur</Button>
                            </Col>
                        </Row>
                    </Container>
                );
            }
            else {
                return (
                    <Container>
                        <Row>
                            <Col>
                                Kunden saknar djur
                            </Col>
                        </Row>
                    </Container>
                );
            }
        }
    }

    if (!props.shown) {
        return <React.Fragment />;
    }
    else {
        return (
            <Modal show={props.shown} onHide={props.onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Gör ett val
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {getButtons()}
                </Modal.Body>
            </Modal>
        );
    }

}

export default JournalOrCreatePopup;